import script from "./BulkEditProductTypeSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkEditProductTypeSelection.vue?vue&type=script&setup=true&lang=js"

import "./BulkEditProductTypeSelection.vue?vue&type=style&index=0&id=30e658f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e658f2"]])

export default __exports__